/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { goodLuckCoreEntitiesOrganizationRoleSchema } from "./organizationRoleSchema.ts";
import { goodLuckCoreEntitiesOrganizationSchema } from "./organizationSchema.ts";
import { goodLuckCoreEntitiesUserSchema } from "./userSchema.ts";
import { z } from "zod/v4";

export const goodLuckCoreEntitiesOrganizationMemberSchema = z.object({
  id: z.optional(z.uuid()),
  organizationId: z.uuid(),
  get organization() {
    return goodLuckCoreEntitiesOrganizationSchema.optional();
  },
  userId: z.string().min(1),
  get user() {
    return goodLuckCoreEntitiesUserSchema.optional();
  },
  roleId: z.int(),
  get role() {
    return goodLuckCoreEntitiesOrganizationRoleSchema.optional();
  },
  joinedAt: z.optional(z.iso.datetime()),
  isBanned: z.optional(z.boolean()),
  bannedAt: z.iso.datetime().nullish(),
  bannedByUserId: z.string().nullish(),
  get bannedByUser() {
    return goodLuckCoreEntitiesUserSchema.optional();
  },
  banReason: z.string().max(500).nullish(),
  isStreamer: z.optional(z.boolean()),
});
